import React, { useRef } from 'react';
import { useDetectOutsideClick } from '../../hooks/useDetectOutsideClick';
import '../DropDownButton/styles.scss';
import { LoadingIcon } from '../../UI';
import TsrSvgIcon from '../../assets/icons';
import { Label } from '../../inputs/Label';
import Tippy from '@tippyjs/react';
import { ButtonsPropsBase } from '../interfaces/Buttons';
import uniqueId from 'lodash/uniqueId';
import { ContextMenuComponent } from '../../menus/contextMenu/ContextMenuComponent';
import './styles.scss';
import { CONTEXT_MENU_MAX_WIDTH } from '../../menus/contextMenu';

interface DropButtonProps extends ButtonsPropsBase {
    logoIcon?: string;
    appendTo?: Element | 'parent' | ((ref: Element) => Element) | undefined;
}

export default function DropButton(props: DropButtonProps & ButtonsPropsBase) {
    const {
        loading = props.loading || false,
        icon = props.icon || undefined,
        title = props.title || undefined,
        theme = props.theme || 'primary',
        array = props.array || [],
        disabled = props.disabled || false,
        className = props.className || '',
        appendTo = props.appendTo || 'parent',
    } = props;
    const container = useRef<HTMLDivElement | null>(null);
    const [open, setOpen] = useDetectOutsideClick(container, false);
    const id = uniqueId('idDropButton-');
    const openDropDownHandler = (open: boolean) => {
        if (disabled) {
            return;
        }
        setOpen(!open);
    };

    return (
        <div className={'dtop-button-container' + (props.className ? ' ' + props.className : '')}>
            <Label id={props.id || id} content={props.label} disabled={props.disabled} labelPosition={props.labelPosition}>
                <div ref={container}>
                    <Tippy
                        onClickOutside={() => {
                            setOpen(false);
                        }}
                        interactive={true}
                        placement={'bottom-start'}
                        visible={open}
                        arrow={false}
                        appendTo={appendTo}
                        offset={[0, 0]}
                        duration={0}
                        theme={'dropDown'}
                        maxWidth={CONTEXT_MENU_MAX_WIDTH}
                        content={
                            <ContextMenuComponent
                                className="overflow-container"
                                items={array}
                                onCloseMenu={() => {
                                    setOpen(false);
                                }}
                            />
                        }
                    >
                        <button
                            type="button"
                            tabIndex={props.disabled ? -1 : 0}
                            className={
                                'drop-down-button ' +
                                (theme ? ' ' + theme : '') +
                                (className ? ' ' + className : '') +
                                (disabled ? ' disabled' : '')
                            }
                            onClick={event => openDropDownHandler(open)}
                        >
                            <div className="button-icon">
                                {loading ? (
                                    <div className="loading-icon">
                                        <LoadingIcon loading={loading} color={theme} />
                                    </div>
                                ) : (
                                    icon && <TsrSvgIcon icon={icon} pointer />
                                )}
                            </div>
                            <span>{title}</span>
                            {open ? <TsrSvgIcon icon={'arrowUp'} pointer /> : <TsrSvgIcon icon={'arrowDown'} pointer />}
                        </button>
                    </Tippy>
                </div>
            </Label>
        </div>
    );
}
